import * as go from "gojs";

export function loadOverview(diagram, objDIV) {
  const $ = go.GraphObject.make;
  const overview = $(go.Overview, objDIV, {
    observed: diagram,
    contentAlignment: go.Spot.Center,
  });
  return overview;
}